module.exports = __webpack_public_path__ + "img/waistband width.0b28b855.png";